import { render } from "./SchoolProjects.vue?vue&type=template&id=485a7ea0&scoped=true"
import script from "./SchoolProjects.vue?vue&type=script&lang=js"
export * from "./SchoolProjects.vue?vue&type=script&lang=js"

import "./SchoolProjects.vue?vue&type=style&index=0&id=485a7ea0&scoped=true&lang=css"

import exportComponent from "D:\\newProjectGit\\HbzsbAdminClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-485a7ea0"]])

export default __exports__